"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderResults = void 0;
var orderJourneyResults_1 = require("./orderJourneyResults");
var orderPlainResults_1 = require("./orderPlainResults");
function orderResults(results, appliedOrderValue) {
    var journeysProperty = "journeys";
    var useJournetsFilter = appliedOrderValue.path.includes(journeysProperty);
    if (useJournetsFilter) {
        return (0, orderJourneyResults_1.orderJourneyResults)(results, appliedOrderValue, journeysProperty);
    }
    return (0, orderPlainResults_1.orderPlainResults)(results, appliedOrderValue);
}
exports.orderResults = orderResults;
//# sourceMappingURL=orderResults.js.map